import { Container, Grid, Typography, Link, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { footers } from '../../constants/footerData';
import { useNavigate } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const SOCIAL_MEDIA_URLS = {
  facebook: 'https://www.facebook.com/arektaboidotcomm/',
  instagram: 'https://www.instagram.com/arekta_boi/',
  linkedIn: 'https://www.linkedin.com/company/arektaboi-com/',
};

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  main: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(2),
  },
  footer: {
    backgroundColor: theme.palette.primary.another,
    padding: theme.spacing(3, 2),
    width: '100%',
  },
  screen: {
    padding: theme.spacing(4),
  },
  socialMediaIcon: {
    cursor: 'pointer',
    transition: 'color 0.3s ease',
    '&:hover, &.Mui-focusVisible': {
      color: theme.palette.secondary.main,
    },
  },
  socialMediaIconMobile: {
    fontSize: '1.6rem !important',
  },
  socialMediaIconDesktop: {
    fontSize: '2rem !important',
  },
  socialMediaContainer: {
    color: theme.palette.primary.main,
    marginTop: 10,
  },
  footerLink: {
    color: theme.palette.mode === 'dark' ? '#E8EAED' : '#FFFFFF',
    cursor: 'pointer',
    textDecoration: 'none',
    fontSize: '0.95rem',
    transition: 'color 0.3s ease, text-decoration 0.3s ease',
    '&:hover': {
      color: theme.palette.secondary.main,
      textDecoration: 'underline',
    },
  },
  sectionHeader: {
    color: theme.palette.secondary.main,
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
}));

const openSocialMediaURL = (type = 'facebook') => {
  window.open(new URL(SOCIAL_MEDIA_URLS[type]), '_blank');
};

const Footer = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <footer className={classes.footer}>
      <Container className={classes.screen}>
        <Grid container spacing={4} justifyContent="space-between">
          {footers.map((footer, index) => (
            <Grid key={'footer-item' + index} item xs={12} sm={6} md={3}>
              <Typography variant="h5" className={classes.sectionHeader}>
                {footer.header}
              </Typography>
              <ul>
                {footer.description.map((item, index) => (
                  <li key={'footer-desc' + index}>
                    <Link
                      className={classes.footerLink}
                      onClick={() => navigate(item.ref)}
                      variant="subtitle1"
                      sx={{ color: '#edebebff' }}
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </Grid>
          ))}

          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h5" color="secondary" className={classes.sectionHeader}>
              Keep in touch
            </Typography>

            <Grid
              className={classes.socialMediaContainer}
              container
              spacing={2}
              justifyContent="flex-start"
            >
              <Grid item>
                <FacebookIcon
                  className={`${classes.socialMediaIcon} ${
                    isMobile ? classes.socialMediaIconMobile : classes.socialMediaIconDesktop
                  }`}
                  onClick={() => openSocialMediaURL('facebook')}
                  sx={{ color: '#edebebff' }}
                />
              </Grid>

              <Grid item>
                <InstagramIcon
                  className={`${classes.socialMediaIcon} ${
                    isMobile ? classes.socialMediaIconMobile : classes.socialMediaIconDesktop
                  }`}
                  onClick={() => openSocialMediaURL('instagram')}
                  sx={{ color: '#edebebff' }}
                />
              </Grid>

              <Grid item>
                <LinkedInIcon
                  className={`${classes.socialMediaIcon} ${
                    isMobile ? classes.socialMediaIconMobile : classes.socialMediaIconDesktop
                  }`}
                  onClick={() => openSocialMediaURL('linkedIn')}
                  sx={{ color: '#edebebff' }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </footer>
  );
};

export default Footer;
